import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

// Which room is the viewer standing in? On the homepage: the last RoomStart above the viewport's middle.
// Elsewhere: the room the route belongs to.
export const useActiveRoom = (fallback) => {
  const { pathname } = useLocation();
  const [active, setActive] = useState(pathname === "/" ? "prismpixel" : fallback);
  const raf = useRef(0);

  useEffect(() => {
    if (pathname !== "/") { setActive(fallback); return undefined; }
    const measure = () => {
      raf.current = 0;
      const mid = window.innerHeight * 0.5;
      let current = "prismpixel";
      document.querySelectorAll("[data-room-boundary]").forEach((el) => {
        if (el.getBoundingClientRect().top <= mid) current = el.dataset.roomBoundary;
      });
      setActive((prev) => (prev === current ? prev : current));
    };
    const onScroll = () => { if (!raf.current) raf.current = requestAnimationFrame(measure); };
    measure();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      cancelAnimationFrame(raf.current);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [pathname, fallback]);

  return active;
};
